export const dateFormatter = (dateString: string, format) => {
  const date = new Date(dateString);

  return format.replace('MM', date.getMonth() + 1)
    .replace('DD', date.getDate())
    .replace('YY', date.getFullYear() % 100);
}
